"use client";
//#region packages/@mantine/core/src/components/ScrollArea/utils/compose-event-handlers.ts
function composeEventHandlers(originalEventHandler, ourEventHandler, { checkForDefaultPrevented = true } = {}) {
	return (event) => {
		originalEventHandler?.(event);
		if (checkForDefaultPrevented === false || !event.defaultPrevented) ourEventHandler?.(event);
	};
}
//#endregion
export { composeEventHandlers };

//# sourceMappingURL=compose-event-handlers.mjs.map